var saving =  document.getElementsByClassName('saving-wrapper');
if (saving.length > 0){
  document.querySelectorAll('.quantity__button').forEach(item => {
      item.addEventListener('click', event => {
          change_packet_info();
      })
    })
  document.querySelector('.quantity__input').addEventListener('change', event => {
    change_packet_info();
  })
}
var saving =  document.getElementsByClassName('custom-saving-wrapper');
if (saving.length > 0){
  document.querySelectorAll('.quantity__button').forEach(item => {
      item.addEventListener('click', event => {
          change_packet_info();
      })
    })
  document.querySelector('.quantity__input').addEventListener('change', event => {
    change_packet_info();
  })
}
function change_packet_info(){
  if (document.querySelector('.custom-saving-wrapper')) {
    let quantity_meters = document.querySelector('.main_product-quantity_input') || document.querySelector('.quantity__input');
    if (!quantity_meters) return; 
    let measurement_value = parseFloat(quantity_meters.getAttribute('data-reference-value')) || 1;
    let current_qty = parseFloat(quantity_meters.value) || 1;
    let total_meters = Math.ceil(current_qty / measurement_value);
    let packet_price = parseFloat(quantity_meters.getAttribute('data-packet-price')) || 0;
    let packet_strike_price = parseFloat(quantity_meters.getAttribute('data-compare-at-price')) || 0;
    var saved = document.querySelector('.custom-saving-wrapper .saving').getAttribute('data-saved');
    saved = saved.replace('€', '');
    saved = saved.replace(',', '.');
    packet_strike_price = Number(saved);
    packet_strike_price = (Math.round((packet_strike_price * total_meters) * 100) / 100).toFixed(2);
    packet_strike_price = (packet_strike_price +'').replace('.', ',');
    packet_strike_price = packet_strike_price +' €';
    let total_packet_price = (packet_price * 1.21 * total_meters / 100).toFixed(2);
    total_packet_price = total_packet_price.toString();
    document.querySelector('.custom-saving-wrapper .total_meters').innerHTML = total_meters + ' ';
    document.querySelector('.custom-saving-wrapper .total_packet_price').innerHTML = total_packet_price.replace('.', ',');
    let savingLine =  document.querySelector('.custom-saving-wrapper .saving');
    if (savingLine){
      document.querySelector('.custom-saving-wrapper .saving span').innerHTML = packet_strike_price;
    }
    if(total_meters > 1){
      document.querySelector('.custom-saving-wrapper .total_multiple').innerHTML = 'Pakete';
    }else{
      document.querySelector('.custom-saving-wrapper .total_multiple').innerHTML = 'Paket';
    }
  }
  else {
    let quantity_meters = document.querySelector('.main_product-quantity_input') || document.querySelector('.quantity__input');
    if (!quantity_meters) return;
    let measurement_value = parseFloat(quantity_meters.getAttribute('data-reference-value')) || 1;
    let current_qty = parseFloat(quantity_meters.value) || 1;
    let total_meters = Math.ceil(current_qty / measurement_value);
    let packet_price = parseFloat(quantity_meters.getAttribute('data-packet-price')) || 0;
    let packet_strike_price = parseFloat(quantity_meters.getAttribute('data-compare-at-price')) || 0;
    let total_packet_price = (packet_price * 1.21 * total_meters / 100).toFixed(2);
    let total_strike_price = (packet_strike_price * total_meters /100 - total_packet_price).toFixed(2);
    total_packet_price = total_packet_price.toString();
    total_strike_price = total_strike_price.toString();
    document.querySelector('.saving-wrapper .total_meters').innerHTML = total_meters + ' ';
    document.querySelector('.saving-wrapper .total_packet_price').innerHTML = total_packet_price.replace('.', ',');
    let savingLine =  document.querySelector('.saving-wrapper .saving');
    if (savingLine){
      document.querySelector('.saving-wrapper .saving span').innerHTML = total_strike_price.replace('.',',');
    }
    if(total_meters > 1){
      document.querySelector('.saving-wrapper .total_multiple').innerHTML = 'Pakete';
    }else{
      document.querySelector('.saving-wrapper .total_multiple').innerHTML = 'Paket';
    }
  }
}
// *** Claculator 
const btnOpenCalculator = document.querySelector('.openCalculator');
const btnCloseCalculator = document.querySelector('.close_calculator');
btnOpenCalculator && btnOpenCalculator.addEventListener('click', openCalculator);
btnCloseCalculator && btnCloseCalculator.addEventListener('click', closeCalculator);
const calc_container = document.querySelector('.calculator_container');
function openCalculator(){
  setCalculatorHeight();
  setTimeout(()=>{
    calc_container.classList.add('open');
    document.querySelector('body').classList.add('calculator_container--open');
  },200)
  document.body.addEventListener('click', onBodyClickCalculator);
  document.querySelector('#shopify-section-header').classList.add('shopify-section-header-sticky', 'animate');
  document.querySelector('#shopify-section-header').classList.remove('shopify-section-header-hidden');
}
function setCalculatorHeight() {
  let topBar = document.getElementById("shopify-section-announcement-bar");
  let header = document.getElementById("shopify-section-header");
  let windowHeight = window.innerHeight ;
  let calculatorHeight;
   if (header.classList.contains('shopify-section-header-sticky')) {
      if (header.classList.contains('shopify-section-header-hidden')) {
          calculatorHeight = windowHeight - header.clientHeight ;
           console.log('1')
        }else{
          calculatorHeight = windowHeight - ( header.clientHeight + topBar.clientHeight);
          console.log('2')
        }
    }else{
     if(window.scrollY < topBar.clientHeight){
       calculatorHeight = windowHeight - ( header.clientHeight  + topBar.clientHeight )
     }else{
       calculatorHeight = windowHeight - ( header.clientHeight )
     }
    }
  calc_container.style.height = `${calculatorHeight}px`;
}
function onBodyClickCalculator(e){
  const hasClass = e.target.classList.contains('calculator_container') 
  if(!hasClass && e.target.classList.contains('transition-body')){
    closeCalculator()
  }
}
function closeCalculator(){
   calc_container.classList.remove('open');
  document.querySelector('body').classList.remove('calculator_container--open');
  document.body.removeEventListener('click', onBodyClickCalculator);
}
// Animation Label
const calculator_input = document.querySelectorAll('.calculator-input');
calculator_input.forEach(function (ell) {
  // Callback function Panels Calculator
  ell.addEventListener('input', calculatePanels);
  // Label Animation On focus
  ell.addEventListener('focus', function() {
    ell.closest('.input-wrapper').classList.add('focused-in');
  });
  ell.addEventListener('focusout', function() { 
    if(ell.value.length < 1 ){
      ell.closest('.input-wrapper').classList.remove('focused-in');
    }
  });
});
// Panels Calcul Logic
const checkBox_buffer = document.querySelector('#calculator_buffer_checkbox');
const ref_val = 1 || parseFloat(document.querySelector(".calculator-inputs").dataset.refValue);
const calculatedResult_btn = document.querySelector(".calculated-result");
// If the check box is updated, the result will be revised.
checkBox_buffer && checkBox_buffer.addEventListener('click', calculatePanels);
// Calculation Function
function calculatePanels() {
  const width_val = parseFloat(document.querySelector("#width-calc").value);
  const height_val = parseFloat(document.querySelector("#height-calc").value);
  let wall_size;
  let result;
  document.getElementById('kalkulator-ergebnis').innerHTML = '';
  if( !Number.isNaN(height_val) && !Number.isNaN(width_val)){
    // wall size metre cube
    wall_size = (width_val * height_val)/10000;
    if (checkBox_buffer.checked){
      let buffed_wallSize = (0.1 * wall_size) + wall_size;
      result =  buffed_wallSize / ref_val;
    }else{
      result = wall_size / ref_val;
    }
    if(!Number.isNaN(result)){
      calculatedResult_btn.innerHTML = `auswählen ${Math.ceil(result)} Stück`
      // Activate the button add
      calculatedResult_btn.removeAttribute('disabled'); 
      calculatedResult_btn.setAttribute('data-qty', Math.ceil(result));
    }else{
       calculatedResult_btn.innerHTML = `Fehler in der Berechnung`
    }
    if (Math.ceil(result)) {
      document.getElementById('kalkulator-ergebnis').innerHTML = 'Du benögst <b>'+ Math.ceil(result) +' m<sup>2</sup></b>';
    }
  }else{
    calculatedResult_btn.innerHTML = `auswählen`;
    calculatedResult_btn.setAttribute('disabled', true)
    calculatedResult_btn.setAttribute('data-qty', '')
  }
}
calculatedResult_btn.addEventListener('click', (e) => {
  console.log(e.target.dataset.qty)
  document.querySelector('.quantity__input').value =  e.target.dataset.qty;
  document.querySelector('.real_quantity__input').value =  e.target.dataset.qty;
  change_packet_info();
  closeCalculator();
  calculator_input.forEach((ell)=>{
    ell.value = ''
  })
})

window.addEventListener('load', function() {
  window.scrollTo(0, window.scrollY + 1); setTimeout(() => window.scrollTo(0, window.scrollY - 1), 0);
})

window.customm2 = async function(event, { variantId, quantity }) {
  var par = event.target.parentElement.parentElement;
  var el = par.getElementsByClassName('quantity__input')[0];
  var key = par.getAttribute('data-key');

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });

  
  el.value = 1;
  el.dispatchEvent(new Event('change', { bubbles: true }));
}
